/** Image affichée quand un produit n'a pas de vignette (catalogue, panier, etc.). */
export const PRODUCT_PLACEHOLDER_IMAGE =
  'https://images.unsplash.com/photo-1630734242356-a6f858790740?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=880';

/** Image affichée quand une catégorie n'a pas d'image (admin + accueil). */
export const CATEGORY_PLACEHOLDER_IMAGE =
  "https://images.unsplash.com/photo-1664455340023-214c33a9d0bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGUtY29tbWVyY2V8ZW58MHx8MHx8fDA%3D";

export const CONSTANTS = {
  pieceIdentificationTypes: [
    { value: "CNI", label: "Carte Nationale d'Identité" },
    { value: "PASSPORT", label: "Passeport" },
    { value: "PERMIS_DE_CONDUITE", label: "Permis de Conduire" },
    { value: "CARTE_CONSULAIRE", label: "Carte Consulaire" },
    { value: "ATTESTATION_IDENTITE", label: "Attestation d’Identité" },
    { value: "CARTE_ETUDIANTE", label: "Carte Étudiante" },
  ],
  categories: [
      { value: "mode_accessoires", label: "Mode & Accessoires" },
      { value: "beaute_sante", label: "Beauté & Santé" },
      { value: "maison_decoration", label: "Maison & Décoration" },
      { value: "electronique_hightech", label: "Électronique & High-Tech" },
      { value: "alimentation_boissons", label: "Alimentation & Boissons" },
      { value: "sport_loisirs", label: "Sport & Loisirs" },
      { value: "auto_moto", label: "Auto & Moto" },
      { value: "produits_numeriques", label: "Produits numériques" },
      { value: "formations_en_ligne", label: "Formations & E-learning" },
      { value: "logiciels_applications", label: "Logiciels & Applications" },
      { value: "musique_photos_videos", label: "Musique, Photos & Vidéos" },
      { value: "services_coaching", label: "Coaching & Consulting" },
      { value: "services_design", label: "Design, Rédaction & Marketing" },
      { value: "services_reservation", label: "Réservations & Voyages" },
      { value: "services_domicile", label: "Services à domicile" },
      { value: "boutique_marque", label: "Boutique de marque" },
      { value: "eco_responsable", label: "Éco-responsable / Durable" },
      { value: "artisanat", label: "Produits artisanaux / Faits main" },
      { value: "local_terroir", label: "Produits locaux / Terroir" },
      { value: "animaux", label: "Produits pour animaux" },
      { value: "enfants_bebes", label: "Produits pour enfants / bébés" },
  ],

  productStatus: [
    { value: "unpublished", label: "Non publié" },
    { value: "published", label: "Publié" },
    { value: "archived", label: "Archivé" },
    { value: "outofstock", label: "En rupture de stock" },
  ]
  };
  